<template>
  <div class="datepickerContent">
    <Datepicker
      :input-class="'calender_button'"
      :wrapper-class="'lesson-date'"
      v-model="date"
      name="datepicker"
    />
    <font-awesome-icon :icon="'calendar'" class="icon"/>
  </div>
</template>

<script lang="ts">
import {
  Component,
  Vue,
  Prop,
} from 'vue-property-decorator'
import Datepicker from 'vuejs-datepicker'
import { Moment } from 'moment'

@Component({
  components: { Datepicker },
})
export default class DateInput extends Vue {
  @Prop() value!: Moment

  private get date() {
    return this.value
  }

  private set date(date) {
    this.$emit('input', date)
    this.$emit('changeDate');
  }
}
</script>

<style scoped>
.lesson-date {
  background: none;
}

.datepickerContent {
  position: relative;
}

.icon {
  position: absolute;
  top:0;
  width: 25px;
  height: 25px;
  margin:auto 0;
  cursor:pointer;
  pointer-events: none;
}

</style>

<style>
  .calender_button {
    border:none;
    display:block;
    background:none;
    cursor:pointer;
    width: 25px;
    height: 25px;
    opacity: 0;
  }
</style>
